"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    setEndDirection = _useStylesUtils.setEndDirection;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    direction = _useContext.direction;
  var _props$view = props.view,
    view = _props$view === void 0 ? 'default' : _props$view,
    gradientFrom = props.gradientFrom,
    _props$gradientTo = props.gradientTo,
    gradientTo = _props$gradientTo === void 0 ? gradientFrom : _props$gradientTo,
    _props$angle = props.angle,
    angle = _props$angle === void 0 ? '180deg' : _props$angle,
    color = props.color;
  var ccItemTagStyle = (0, _react.useMemo)(function () {
    var viewProps = function viewProps() {
      if (view === 'horizontal') {
        return {
          fontSize: pxToRem(11),
          padding: "0 ".concat(pxToRem(10)),
          minWidth: pxToRem(35.29),
          height: pxToRem(14.7),
          lineHeight: pxToRem(14.7),
          boxSizing: 'border-box'
        };
      }
      return {};
    };
    var ccItemTag = (0, _css.css)(_objectSpread(_objectSpread({
      fontFamily: fontFamily,
      fontSize: pxToRem(16),
      display: 'inline-flex',
      position: 'relative',
      justifyContent: 'center',
      alignItems: 'center',
      padding: "0 ".concat(pxToRem(16)),
      borderRadius: pxToRem(4),
      zIndex: 1
    }, viewProps()), {}, {
      background: "linear-gradient(".concat(angle, ", ").concat(gradientFrom, " 35%, ").concat(gradientTo, " 100%)"),
      color: color
    }));
    var ccItemTagSpout = (0, _css.css)(_objectSpread(_objectSpread({
      position: 'absolute',
      width: pxToRem(8),
      height: pxToRem(8),
      backgroundColor: gradientFrom,
      top: 0
    }, setEndDirection(-3)), {}, {
      transform: direction === 'rtl' ? 'skew(-60deg, 0deg) rotateX(45deg)' : 'skew(60deg, 0deg) rotateX(-45deg)'
    }));
    return {
      ccItemTag: ccItemTag,
      ccItemTagSpout: ccItemTagSpout
    };
  }, [angle, color, direction, fontFamily, gradientFrom, gradientTo, pxToRem, setEndDirection, view]);
  return {
    'cc-Item__tag': ccItemTagStyle.ccItemTag,
    'cc-Item__tag__spout': ccItemTagStyle.ccItemTagSpout
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;